/* eslint-disable max-lines-per-function */
import { FREQUENCY_INTERVAL } from '../common/constants';
import { reportLog, errStr } from './report';
const { deviceId: deviceIdHelper } = require('@futuweb/business-cipher');
const {
    store: { variable }
} = require('@futuweb/fego-render');
const {
    library: { dayjs }
} = require('@futuweb/fego-bridge');

export default function useJudgeModalOpen(props) {
    // FEGO 的页面 ID
    const appId = variable.data.APP_ID || window._appID;
    // 设备 ID
    const deviceId = deviceIdHelper.get();
    // 组件的 ID
    const tplId = props.tpl.id;

    /**
     * 展示次数 key
     * 这里和产品确对齐，多语言下组件 ID 不同，相当于不同语言频次是独立的，产品可以接受。
     * 如果需要多页面共享频次，则需要再加多一个标识用于共享配置。
     * @returns {string} 固定前缀 + 设备ID + appId + 组件ID
     */
    const getKey = () => `FEGO:basic_up_modal_open_logs:${deviceId}:${appId}:${tplId}`;

    /**
     * 获取 dayjs 实例 （以服务端时间为准）
     */
    const getDayjsIns = (() => {
        // 获取服务器时间与客户端时间的时间差，确保后面的时间获取都是以服务端为准
        const serverClientTimeDiff = dayjs().diff(dayjs.unix(variable.data.NOW_SERVER || dayjs().unix()));
        return () => {
            // 获取客户端时间 dayjs 实例
            const now = dayjs();
            // 客户端时间 - （服务端时间与客户端时间差）= 当前正确的服务端时间
            return now.subtract(serverClientTimeDiff);
        };
    })();

    /**
     * 获取弹窗展示记录 (localStorage)
     * @returns {array} []
     */
    const getOpenRecords = () => {
        const key = getKey();
        const data = localStorage.getItem(key);
        return JSON.parse(data || '[]');
    };

    /**
     * 记录弹窗展示记录 (localStorage)
     */
    const recordOpen = () => {
        const time = getDayjsIns().unix();
        const key = getKey();
        const data = getOpenRecords();
        data.push(time);
        localStorage.setItem(key, JSON.stringify(data));
        reportLog(
            {
                message: '[上拉弹窗]记录弹窗',
                tpl: props.tpl,
                appId,
                key,
                time,
                uid: variable.data.UID
            },
            'info'
        );
    };

    /**
     * 检查本次是否展示弹窗
     * @returns {boolean} true / false
     */
    const judgeModalOpen = () => {
        try {
            // 周期 - 如果是不限制的情况下，不走频次逻辑
            const interval = props?.frequencyInterval;
            if (!interval || interval === FREQUENCY_INTERVAL.NO_LIMIT) {
                return true;
            }

            // 次数
            const times = props?.frequencyTimes ?? 0;
            // 总的活动期间的上限
            const limit = props?.frequencyLimit ?? 0;
            // 获取弹窗记录
            const records = getOpenRecords();
            // 获取当前 dayjs 实例
            const dayjsNow = getDayjsIns();

            // 总弹窗次数已经 > 弹窗上限
            if (records.length >= limit) {
                reportLog(
                    {
                        message: '[上拉弹窗]判断已达弹窗上限',
                        tpl: props.tpl,
                        appId,
                        key: getKey(),
                        recordsLength: records.length,
                        uid: variable.data.UID
                    },
                    'info'
                );
                return false;
            }

            let start;
            if (interval === FREQUENCY_INTERVAL.DAILY) {
                // 每天 - 获取当天开始时间
                start = dayjsNow.startOf('day');
            } else if (interval === FREQUENCY_INTERVAL.WEEKLY) {
                // 每周 - 获取本周开始时间
                start = dayjsNow.startOf('week');
            } else {
                // 不合法配置
                reportLog(
                    {
                        message: '[上拉弹窗]非法配置',
                        tpl: props.tpl,
                        appId,
                        key: getKey(),
                        uid: variable.data.UID
                    },
                    'error'
                );
                return false;
            }

            // 获取当前周期内的弹窗次数
            const count = records.filter((time) => dayjs.unix(time).isAfter(start))?.length ?? 0;

            reportLog(
                {
                    message: '[上拉弹窗]当前周期内弹窗次数',
                    tpl: props.tpl,
                    appId,
                    key: getKey(),
                    count,
                    uid: variable.data.UID
                },
                'info'
            );

            // 当前弹窗次数小于周期内上限，则可弹窗
            return count < times;
        } catch (err) {
            reportLog(
                {
                    message: '[上拉弹窗]判断是否需要展示失败',
                    err: errStr(err),
                    tpl: props.tpl,
                    appId
                },
                'error'
            );
        }
    };

    return {
        judgeModalOpen,
        recordOpen
    };
}
